/**
 * bl-filters.js
 * Controls the horizontal filter dropdowns on desktop.
 * Intercepts events in the capture phase to bypass the theme's height animations,
 * ensuring flawless one-at-a-time accordion behavior and persistence across AJAX reloads.
 */
(function () {
  'use strict';

  if (window.blFiltersInitialized) return;
  window.blFiltersInitialized = true;

  function updateDropdownHeight(details, isOpen, topbar) {
    var container = topbar ? topbar.closest('.filter--container') : null;
    if (!container) return;

    if (!isOpen) {
      // If we are closing, reset margin-bottom immediately
      container.style.setProperty('--dropdown-height', '0px');
    } else {
      // If we are opening, measure the inner body height dynamically
      var body = details.querySelector('.filter-group__body');
      if (body) {
        // Temporarily display block to measure scrollHeight
        var origDisplay = body.style.display;
        body.style.display = 'block';
        
        // Calculate total height including paddings
        var height = body.scrollHeight;
        
        body.style.display = origDisplay;
        
        // Set CSS variable on container
        container.style.setProperty('--dropdown-height', height + 'px');
      }
    }
  }

  // Open / toggle filters
  document.addEventListener('click', function (e) {
    var summary = e.target.closest('.collection_filter_topbar .filter-group > details > summary');
    if (!summary) return;

    // Intercept click to prevent the theme's JS from executing its transition logic
    e.preventDefault();
    e.stopPropagation();

    var details = summary.parentElement;
    var isOpen = details.hasAttribute('open');
    var topbar = summary.closest('.collection_filter_topbar');

    // On mobile (drawer open), allow multiple panels open simultaneously.
    // On desktop, keep the one-at-a-time behaviour.
    if (topbar && !mobileDrawerOpen) {
      // Close all other filter details in this topbar
      topbar.querySelectorAll('.filter-group > details').forEach(function (d) {
        if (d !== details) {
          d.removeAttribute('open');
        }
      });
    }

    // Toggle the clicked details element & update container padding
    if (isOpen) {
      details.removeAttribute('open');
      updateDropdownHeight(details, false, topbar);
    } else {
      details.setAttribute('open', '');
      updateDropdownHeight(details, true, topbar);
    }
  }, true); // Capture phase is key to intercept before theme JS

  // Click outside to close open filters
  document.addEventListener('click', function (e) {
    if (e.target.closest('.collection_filter_topbar')) return;
    document.querySelectorAll('.collection_filter_topbar .filter-group > details[open]').forEach(function (d) {
      d.removeAttribute('open');
      var container = d.closest('.filter--container');
      if (container) {
        container.style.setProperty('--dropdown-height', '0px');
      }
    });
  });

  // Handle click on Clear All Filters button
  document.addEventListener('click', function (e) {
    var clearButton = e.target.closest('#clear-all-filters');
    if (!clearButton) return;

    e.preventDefault();
    e.stopPropagation();

    var form = clearButton.closest('form');
    if (!form) return;

    // Uncheck all checkboxes
    var checkboxes = form.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach(function (cb) {
      cb.checked = false;
    });

    // Reset price inputs
    var numberInputs = form.querySelectorAll('input[type="number"]');
    numberInputs.forEach(function (input) {
      input.value = '';
    });

    // Close all open filter dropdowns and hide the overlay
    document.querySelectorAll('.collection_filter_topbar .filter-group > details[open]').forEach(function (d) {
      d.removeAttribute('open');
      var cont = d.closest('.filter--container');
      if (cont) cont.style.setProperty('--dropdown-height', '0px');
    });
    var _ov = document.getElementById('filter-page-overlay');
    if (_ov) _ov.classList.remove('overlay--active');

    // Trigger input event to let theme's collection-filters-form AJAX load the new collection
    if (checkboxes.length > 0) {
      checkboxes[0].dispatchEvent(new Event('input', { bubbles: true }));
    } else {
      form.dispatchEvent(new Event('input', { bubbles: true }));
    }
  });

  // Handle click on individual group Clear Filters button
  document.addEventListener('click', function (e) {
    var clearFiltersSpan = e.target.closest('.clear-filters');
    if (!clearFiltersSpan) return;

    e.preventDefault();
    e.stopPropagation();

    var filterGroup = clearFiltersSpan.closest('.filter-group');
    if (!filterGroup) return;

    // Uncheck all checkboxes inside this filter group only
    var checkboxes = filterGroup.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach(function (cb) {
      cb.checked = false;
    });

    // Reset price inputs inside this filter group only
    var numberInputs = filterGroup.querySelectorAll('input[type="number"]');
    numberInputs.forEach(function (input) {
      input.value = '';
    });

    // Close all open filter dropdowns and hide the overlay
    document.querySelectorAll('.collection_filter_topbar .filter-group > details[open]').forEach(function (d) {
      d.removeAttribute('open');
      var cont = d.closest('.filter--container');
      if (cont) cont.style.setProperty('--dropdown-height', '0px');
    });
    var _ov2 = document.getElementById('filter-page-overlay');
    if (_ov2) _ov2.classList.remove('overlay--active');

    // Trigger input event to let theme's collection-filters-form AJAX load the new collection
    if (checkboxes.length > 0) {
      checkboxes[0].dispatchEvent(new Event('input', { bubbles: true }));
    } else {
      var form = filterGroup.closest('form');
      if (form) {
        form.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
  });

  // Self-healing observer to reset --dropdown-height if all details are closed (e.g. after AJAX reload)
    var container = document.querySelector('.filter--container');
  if (container) {
    var observer = new MutationObserver(function () {
      var hasOpen = container.querySelector('.collection_filter_topbar .filter-group > details[open]');
      if (!hasOpen) {
        container.style.setProperty('--dropdown-height', '0px');
      }
    });
    observer.observe(container, { childList: true, subtree: true });
  }

  // --- Desktop Page Overlay (shown when any filter or sort is open) ---
  function initDesktopOverlay() {
    // Only run on desktop
    if (window.innerWidth <= 920) return;

    // Disable overlay on search results page
    if (window.location.pathname.indexOf('/search') !== -1) return;

    // Create overlay element
    var overlay = document.getElementById('filter-page-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'filter-page-overlay';
      document.body.appendChild(overlay);
    }

    function showOverlay() {
      overlay.classList.add('overlay--active');
    }

    function hideOverlay() {
      overlay.classList.remove('overlay--active');
    }

    function syncOverlay() {
      // Never show overlay on mobile — the mobile drawer has its own underlay
      if (window.innerWidth <= 920) {
        hideOverlay();
        return;
      }
      var hasOpenFilter = document.querySelector('.collection_filter_topbar .filter-group > details[open]');
      var sortBtn = document.querySelector('.popout--sort .popout__toggle');
      var hasOpenSort = sortBtn && sortBtn.getAttribute('aria-expanded') === 'true';
      if (hasOpenFilter || hasOpenSort) {
        showOverlay();
      } else {
        hideOverlay();
      }
    }

    // Watch filter details for open/close changes
    var topbar = document.querySelector('.collection_filter_topbar');
    if (topbar) {
      var filterObs = new MutationObserver(syncOverlay);
      filterObs.observe(topbar, { 
        attributes: true, 
        childList: true, 
        subtree: true, 
        attributeFilter: ['open'] 
      });
    }

    // Watch sort button for aria-expanded changes
    var sortContainer = document.querySelector('.filter--sort');
    if (sortContainer) {
      var sortObs = new MutationObserver(syncOverlay);
      sortObs.observe(sortContainer, { 
        attributes: true, 
        childList: true, 
        subtree: true, 
        attributeFilter: ['aria-expanded', 'class'] 
      });
    }

    // Watch products grid to sync overlay when AJAX loading finishes
    var productsGrid = document.querySelector('[data-products-grid]');
    if (productsGrid) {
      var productsObs = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'class') {
            var isLoading = productsGrid.classList.contains('is-loading');
            if (!isLoading) {
              // AJAX load has finished, sync the overlay state
              syncOverlay();
            }
          }
        });
      });
      productsObs.observe(productsGrid, { attributes: true });
    }


    // Clicking the overlay closes all open filters and sort
    overlay.addEventListener('click', function () {
      // Close all filter panels
      document.querySelectorAll('.collection_filter_topbar .filter-group > details[open]').forEach(function (d) {
        d.removeAttribute('open');
        var cont = d.closest('.filter--container');
        if (cont) cont.style.setProperty('--dropdown-height', '0px');
      });

      // Close the sort popout if it's open
      var sortBtn = document.querySelector('.popout--sort .popout__toggle[aria-expanded="true"]');
      if (sortBtn) sortBtn.click();

      hideOverlay();
    });
  }

  initDesktopOverlay();

  // --- Mobile Drawer Toggle Logic ---


  // Flag: true when mobile drawer is open and AJAX should be suppressed
  var mobileDrawerOpen = false;

  // Intercept input events from checkboxes/inputs while drawer is open (capture phase)
  // This prevents the theme's collection-filters-form from firing AJAX on every checkbox toggle
  document.addEventListener('input', function (e) {
    if (!mobileDrawerOpen) return;

    var form = e.target.closest('[data-collection-filters-form]');
    if (!form) return;

    // Allow the event to update the element's value/checked state,
    // but stop it from bubbling up to collection-filters-form which fires AJAX
    e.stopPropagation();
  }, true); // capture phase — runs before the theme's bubble-phase listener

  document.addEventListener('DOMContentLoaded', function () {
    initMobileDrawer();
  });

  // Also initialize immediately in case DOMContentLoaded has already fired
  initMobileDrawer();

  function initMobileDrawer() {
    var drawer = document.querySelector('.collection_filter_topbar');
    if (!drawer) return;

    function openDrawer() {
      mobileDrawerOpen = true;
      drawer.classList.add('drawer--open');
      document.body.classList.add('mobile-drawer-active');
      document.body.style.overflow = 'hidden';
      // Ensure the desktop overlay is not visible on mobile
      var pgOverlay = document.getElementById('filter-page-overlay');
      if (pgOverlay) pgOverlay.classList.remove('overlay--active');
    }

    function closeDrawer() {
      mobileDrawerOpen = false;
      drawer.classList.remove('drawer--open');
      document.body.classList.remove('mobile-drawer-active');
      document.body.style.overflow = '';
    }

    function applyFilters() {
      // Trigger the AJAX reload now that Apply is clicked
      var form = drawer.querySelector('[data-collection-filters-form]');
      if (!form) return;
      var firstCheckbox = form.querySelector('input[type="checkbox"], input[type="number"]');
      if (firstCheckbox) {
        // Temporarily disable our suppression so the event fires through
        mobileDrawerOpen = false;
        firstCheckbox.dispatchEvent(new Event('input', { bubbles: true }));
        mobileDrawerOpen = false; // stays false — drawer will close
      } else {
        mobileDrawerOpen = false;
        form.dispatchEvent(new Event('input', { bubbles: true }));
        mobileDrawerOpen = false;
      }
    }

    function clearAndApply() {
      var form = drawer.querySelector('[data-collection-filters-form]');
      if (!form) return;

      // Uncheck everything
      form.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
        cb.checked = false;
      });
      form.querySelectorAll('input[type="number"]').forEach(function (input) {
        input.value = '';
      });

      // Apply immediately (show all products)
      mobileDrawerOpen = false;
      var firstEl = form.querySelector('input[type="checkbox"], input[type="number"]');
      if (firstEl) {
        firstEl.dispatchEvent(new Event('input', { bubbles: true }));
      } else {
        form.dispatchEvent(new Event('input', { bubbles: true }));
      }
      mobileDrawerOpen = false;
    }

    // All mobile drawer button interactions
    document.addEventListener('click', function (e) {
      if (e.target.closest('#mobile-filter-trigger')) {
        e.preventDefault();
        openDrawer();
      } else if (e.target.closest('.mobile-drawer-btn--apply')) {
        applyFilters();
        closeDrawer();
      } else if (e.target.closest('.mobile-drawer-btn--clear')) {
        e.preventDefault();
        clearAndApply();
        closeDrawer();
      } else if (e.target.closest('.mobile-drawer-close')) {
        closeDrawer();
      }
    });

    // Allow multiple accordion panels to be open simultaneously on mobile
    // (Override the desktop one-at-a-time behaviour only when drawer is open)
    document.addEventListener('click', function (e) {
      if (!mobileDrawerOpen) return;
      var summary = e.target.closest('.collection_filter_topbar .filter-group > details > summary');
      if (!summary) return;

      // We only need to suppress the "close others" logic here — the capture-phase
      // listener above already handles the toggle via e.stopPropagation in capture.
      // Re-open ALL panels independently; do NOT close siblings on mobile.
    }, false);
  }
})();